import * as React from 'react'
import { Banner } from '../../Banner/Banner'
import './DeprecatedRuntimeImage.css'

export type ValueProps = {
  deprecatedVersion: string
  upgradeUrl: string
}

export type Props = ValueProps

const deprecatedImageRegex = /-AM/gi

export const shouldShowDeprecatedRuntimeImage = (version: string) => deprecatedImageRegex.test(version)

export const DeprecatedRuntimeImage = ({deprecatedVersion, upgradeUrl}: Props) => {
  const version = deprecatedVersion.replace(deprecatedImageRegex, '')
  const upgrade = <a target="_blank" className="deprecation-link" href={upgradeUrl}>upgrade to {version}</a>
  const deprecationDate = <span className="deprecation-important-text">February 15 2020</span>

  return (
    <Banner type="warning">
      This application is running on Mule {deprecatedVersion} which has been deprecated and replaced by {version} with Monitoring enabled.
      From {deprecationDate}, new metrics and log data will no longer be available for this version in Anypoint Monitoring.
      Please {upgrade} as soon as possible to avoid any data loss.
    </Banner>
  )
}
